import ScheduleButton from "@components/ui/schedule-button";
import { PL } from "@components/ui/typography";
import Section from "@layouts/section";
import { display } from "../../ui/typography/typography.module.css";
import React, { createElement } from "react";
type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
interface ServicespageCtaProps {
  title: string;
  description: string;
  ctaBtn: string;
  ctaHint?: string;
  heading?: HeadingType;
  handleClick: () => void;
}
import LottieAnimation from "@/components/lottie";
import AnimationCTAsectionDesktop from "@animations/cta-section/v3/ror-migration-services-footer-desktop.json";
import CtaSupportText from "@/components/cta-support-text";

const ServicespageCta: React.FC<ServicespageCtaProps> = ({
  title,
  description,
  ctaBtn,
  ctaHint,
  handleClick,
  heading = "h2"
}) => {
  const Heading = createElement(heading, { className: `${display}` }, title);
  return (
    <Section>
      <div className="bg-primary text-emerald-50 py-24 md:py-32 px-6 rounded-2xl md:rounded-4xl text-center">
        <div className={`${display} max-w-5xl mx-auto`}>{Heading}</div>
        <PL className="mt-12 max-w-2xl mx-auto">{description}</PL>
        <ScheduleButton
          variant="dark"
          className="inline-block mt-16 z-10 relative"
          size="lg"
          onClick={handleClick}
        >
          {ctaBtn}
        </ScheduleButton>

        <div className="relative z-[5] -mx-6">
          <LottieAnimation
            animationData={AnimationCTAsectionDesktop}
            className="absolute -top-12 w-full h-10"
          />
        </div>
        <CtaSupportText>{ctaHint}</CtaSupportText>
      </div>
    </Section>
  );
};

export default ServicespageCta;
